import type { track as TrackType } from "pro-features/components/WithTrack/src/context";
import { allTrackers } from "app/services/track/track";

import type { BenchmarkMetricName } from "../../types/api.types";
import type { WebsiteLinkMetricName } from "../../types/common";

type DomainTypeSchema = "primary" | "competitor";

type MetricTrackingEntity = {
    trackSeeAllCompetitorsOpen(name: BenchmarkMetricName): void;
    trackLinkClick(domainType: DomainTypeSchema, metric: WebsiteLinkMetricName): void;
};

export const createMetricTracking = (track: TrackType): MetricTrackingEntity => {
    return {
        trackSeeAllCompetitorsOpen(name) {
            track("see all competitors", "click", "see all competitors", { metricName: name });
        },
        trackLinkClick(domainType, metric) {
            track("button", "click", `analyse domain/${domainType}/${metric}`);
        },
    };
};

export default createMetricTracking(allTrackers.dispatchTrackEvent.bind(allTrackers));
